import { render, staticRenderFns } from "./createExtension.vue?vue&type=template&id=4481c19c"
import script from "./createExtension.vue?vue&type=script&lang=js"
export * from "./createExtension.vue?vue&type=script&lang=js"
import style0 from "./createExtension.vue?vue&type=style&index=0&id=4481c19c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports